module.exports = __webpack_public_path__ + "img/bluesky3100_23.066d5fca.jpg";